import React, { useState } from 'react';
import api from '../../services/api';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AlertMessage from '../Alert';

export const DeleteModal = ({  endpoint, onConfirm, requestBody, style, content }:any) => {
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleConfirm = async () => {
    try {
       await api.post(`${endpoint}`, requestBody);
       setAlert({ show: true, message: 'Item excluído com sucesso!', variant: 'success' });
       onConfirm(); // Chama a função de callback
    } catch (error) {
      console.error("Erro ao tentar excluir:", error);
      setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
    }
    handleClose();
  };
  
  return (
    <>
      <Button variant="danger" onClick={handleShow} style={style}>
        {content ? content : 'Excluir'}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmação de exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />
    </>
  );
};
